import { mapState, mapGetters } from 'vuex';
export const answerMixin = {
         computed: {

           ...mapState({
             poll: (state) => state.poll.poll,
           }),

           ...mapGetters(['isDeadlinePassed']),

           pleaseAnswer() {
             if (this.poll.closed) {
               return this.$t('choiceDialog.pollClosed');
             }

             if (this.isDeadlinePassed) {
               return this.$t('choiceDialog.pollExpired');
             }

             return this.$t('choiceDialog.pleaseAnswer');
           },

           cssProvideAnswer() {
             if (this.poll.closed || this.isDeadlinePassed) {
               return 'k-disabled';
             }
             return 'text-underline text-primary editable-field font-weight-600';
           },
           choiceConfig() {
             const choice_config = this.poll.choice_config;
             if (!choice_config) {
               console.error('No choiceConfig available');
               return [];
             }
             return choice_config.additional_answers;
           },
         },

         methods: {
           renderChoiceAnswer(index, answer) {
             if (answer.value === null || answer.value === '') return '--';
             console.info('renderChoiceAnswer', answer, index);
             const choice_config = this.poll.choice_config;
             const answerCfg = choice_config.additional_answers[index];
             const value = answerCfg.values[answer.value].value;
             return value;
           },

           renderAnswerLable(index) {
             const choice_config = this.poll.choice_config;
             return choice_config.additional_answers[index].labelValue;
           },

           isAnswerVisible(value, index) {
             const config = this.choiceConfig;
             switch (config[index].main_answer.code) {
               case 'always':
                 return true;
               case 'main_answer_is_yes':
                 return value > 0;
               case 'main_answer_is_no':
                 return value == 0;
             }
           },
         },
       };
